import { render } from "./LabelDescriptionField.vue?vue&type=template&id=730aa103"
import script from "./LabelDescriptionField.vue?vue&type=script&lang=js"
export * from "./LabelDescriptionField.vue?vue&type=script&lang=js"

import "../styles/LabelDescriptionField.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__